import React from 'react';
import CellAbstract from './CellAbstract';
import classNames from 'classnames';
import { isFunction } from 'lodash';
import PuzzleButton from '../../UI/button/PuzzleButton';
import { CELL_ICON_PROPS } from './Types';

class CellIcon extends CellAbstract<CELL_ICON_PROPS, {}> {
  private getAction = () => {
    const { cellConfig = {}, dataItem } = this.props;
    const { action, actions = [], getAction } = cellConfig;
    const value = this.getValue();
    let returnValue;

    if (isFunction(getAction)) {
      returnValue = getAction(value, dataItem);
    } else if (action) {
      returnValue = action;
    } else {
      const [falsyAction, truthyAction] = actions;
      returnValue = value ? truthyAction : falsyAction;
    }

    return returnValue;
  };

  private getIcon = () => {
    const { cellConfig = {}, dataItem } = this.props;
    const { icon, icons = [], getIcon } = cellConfig;
    const value = this.getValue();
    let returnValue;

    if (isFunction(getIcon)) {
      returnValue = getIcon(value, dataItem);
    } else if (icon) {
      returnValue = icon;
    } else {
      const [falsyIcon, truthyIcon] = icons;
      returnValue = {
        [truthyIcon]: value,
        [falsyIcon]: !value
      };
    }

    return returnValue;
  };

  private getTooltip = () => {
    const { cellConfig = {}, dataItem } = this.props;
    const { tooltip, tooltips = [], getTooltip } = cellConfig;
    const value = this.getValue();
    let returnValue;

    if (isFunction(getTooltip)) {
      returnValue = getTooltip(value, dataItem);
    } else if (tooltip) {
      returnValue = tooltip;
    } else {
      const [falsyTooltip, truthyTooltip] = tooltips;
      returnValue = value ? truthyTooltip : falsyTooltip;
    }

    return returnValue;
  };

  private getValue = () => {
    const { dataItem, dataIndex, field } = this.props;
    return dataItem[(field || dataIndex)];
  };

  private getAdditionalConfig = () => {
    const { cellConfig = {} } = this.props;
    const { size = 'medium', themeColor, fillMode = 'flat' } = cellConfig;
    return { size, themeColor, fillMode };
  };

  private onClick = () => {
    this.dispatch(this.getAction(), '', { dataItem: this.props.dataItem });
  };

  render() {
    const { renderEmptyCell = false } = this.props?.cellConfig;
    const action = this.getAction();
    const icon = this.getIcon();
    const additionalConfig = this.getAdditionalConfig();
    const tooltip = this.getTooltip();
    const title = tooltip ? (tooltip?.title || tooltip) : undefined;
    const iconCls = classNames('tp-icon', 'tp-icon-grid-cell', icon);

    const cmp = action
      ? (
        <PuzzleButton
          iconClass={iconCls}
          onClick={this.onClick}
          tabIndex={0}
          titleText={title}
          {...additionalConfig}
        />
      )
      : (
        <span
          className={iconCls}
          title={title}
        />
      );

    const renderType = renderEmptyCell && !title ? null : cmp;

    return this.renderCell(renderType, tooltip);
  }
}

export default CellIcon;
